export default __webpack_public_path__ + "static/media/nervous-blob.d7571b98.gif";